
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as logoutUcooZuBFq6Y_45qkSHe3Slgw7Ozl4rsMv5kY96MDZ8icoMeta } from "/app/pages/logout.vue?macro=true";
import { default as cookies7IsQMQZ91ParjOwHFEj6VICbqcticg0fuEDXa9tKIEEMeta } from "/app/pages/cookies.vue?macro=true";
import { default as privacyxyrJyjSeOpGN_D08QZsO5Csr7DLueZBtja09XVxe_45u0Meta } from "/app/pages/privacy.vue?macro=true";
import { default as profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta } from "/app/pages/profile.vue?macro=true";
import { default as sign_45inbPbFKYUyY8JVFBcm2aFVb4SDTfLJ_452ZMn8gY1OTmgtsMeta } from "/app/pages/sign-in.vue?macro=true";
import { default as supporta84A2tb9xESxO6bOKWmFoDLo2va0te5rR2kefeEwfjUMeta } from "/app/pages/support.vue?macro=true";
import { default as authorizebxIwcrqQKBE0Vl5ZZdCbDPtAYC_45ks9MhmSy_45CbLLX2sMeta } from "/app/pages/authorize.vue?macro=true";
import { default as auth_45errortlyiiM_ajFw9AVCQbjXlzVBdqoleFtiGNosXQrGtbwAMeta } from "/app/pages/auth-error.vue?macro=true";
import { default as styleguidekOZput7JIMcezS2kJtDgGC_MGA6DJaNnCUxwdFe9qh4Meta } from "/app/pages/styleguide.vue?macro=true";
import { default as switch_45ame_M0kKMEgISkV_JFQvjaRqreaW8AmrKsW1rh_QC9nTkcMeta } from "/app/pages/switch-ame.vue?macro=true";
import { default as listt7N_454ibscqk1TsGAF5X3R1UfewJKmJEXikPX_QcFl48Meta } from "/app/pages/appeals/list.vue?macro=true";
import { default as openGOoy_0rZ8BPf_45zCxBWdlT_45QtmcavxuMsvR7Y6_33xWwMeta } from "/app/pages/appeals/open.vue?macro=true";
import { default as auth_45detailson2XVjKGhQwilbYuSYJwXDtZUzZEsbSAJx_45qxXM5qcYMeta } from "/app/pages/auth-details.vue?macro=true";
import { default as not_45eligibleq3yQpD9kRPfnbrTwMHY_45jCjr7nLSO4HHI2353wOWtqEMeta } from "/app/pages/not-eligible.vue?macro=true";
import { default as accessibilitykJPhdRnYvAfYbQlvjUKjY_45qYBOs51I_YeyB3And3Sm4Meta } from "/app/pages/accessibility.vue?macro=true";
import { default as index2pPNQG__45kQchHvNrtuj0_SFmj6ztvuE1x3P3zFJDy6sMeta } from "/app/pages/appeals/index.vue?macro=true";
import { default as closed9_nlpcIb1YRDmxaPMnCpTB7RrsA_45g_crjrNi4LC6fVsMeta } from "/app/pages/appeals/closed.vue?macro=true";
import { default as _91id_935lF6LcC4IFG15MPgtlaHEiVGKcZs22Gi8l_45DQrZ3CZwMeta } from "/app/pages/fimas/add/[id].vue?macro=true";
import { default as indexuiHO2nk_Hz7ZeolDitQdyjhRIkK7mOguTSFcUnUxi0MMeta } from "/app/pages/subsidies/index.vue?macro=true";
import { default as listciCShQhVkvv7gy06G0wY8Q9iof9c1qv8m95PTqMAJMIMeta } from "/app/pages/applications/list.vue?macro=true";
import { default as _91id_93tBzdkYOMa7d4BDXXocQMMuNjIdQ0Lhar9cEgUP6O1PwMeta } from "/app/pages/fimas/select/[id].vue?macro=true";
import { default as _91id_93yqPfnD7AplFwzZgg4UclLLyBGj41u9wubEkgNSlRT10Meta } from "/app/pages/fimas/update/[id].vue?macro=true";
import { default as user_45satisfactionuwqjomqPFT7jSPQbsE4RiaasWAFZS8zVZARHiLnCnl4Meta } from "/app/pages/user-satisfaction.vue?macro=true";
import { default as index129XfFjVRJxJIFUZmY_452lpAzoe0BKCgckr1g4FIJBvQMeta } from "/app/pages/appeals/[id]/index.vue?macro=true";
import { default as indexGv_45Zqj1puN7ITJB40Oy0KfPdX2n2TW4m_vwLp3s7BywMeta } from "/app/pages/applications/index.vue?macro=true";
import { default as _91id_93RG6hLbp6STJcrxoVdN5taTOKRaJ156o2vFafMg1YjU8Meta } from "/app/pages/fimas/preview/[id].vue?macro=true";
import { default as activeyZ1_UfxaXXJardGzQbBwYXmVefNTX7Gc1cnPt2mt0eMMeta } from "/app/pages/applications/active.vue?macro=true";
import { default as draftsEevC2V4U33BI2qDXYeE4rknQcWgY3MB50kRhyh8uYVgMeta } from "/app/pages/applications/drafts.vue?macro=true";
import { default as listFsGqJscqf4tEWC6c8xeRobsY_rwdqcI0GptNNznR75kMeta } from "/app/pages/payment-claims/list.vue?macro=true";
import { default as historySTCabVfSFTryXYzwd5sXIKDCY34T0HgboGplgcHq0GMMeta } from "/app/pages/applications/history.vue?macro=true";
import { default as index_oWEB8xoh29Lqc6KneRceOMidWxQwwSeuz2qjfmgFUcMeta } from "/app/pages/payment-claims/index.vue?macro=true";
import { default as withdrawYzKGpltzLc6kek8R_RMdg8Guy8y4H0Aucx6LjLAB5I4Meta } from "/app/pages/appeals/[id]/withdraw.vue?macro=true";
import { default as indexfEvuQag7eSv0BJ4mUkuknOkuRp560dZPj44u_Q9wt6sMeta } from "/app/pages/applications/[id]/index.vue?macro=true";
import { default as deleteroZ4aUzH8ABSPsK2VHSM25MzOhj_wHActQ2gX_KRmPEMeta } from "/app/pages/applications/[id]/delete.vue?macro=true";
import { default as _91id_93ubvNgOTIFHwYPiT6x0nyTMvr2zefsUMeJjodkHZb_80Meta } from "/app/pages/applications/appeal/[id].vue?macro=true";
import { default as indexxyZxdqfiLNA0ybGa4TYueAInqF1A4VrEs25CbEEC7fcMeta } from "/app/pages/payment-claims/[id]/index.vue?macro=true";
import { default as withdrawVQ0fx6DS8VbWCXulxH6ctXV4un94Mz97YOJuQsINZ4IMeta } from "/app/pages/applications/[id]/withdraw.vue?macro=true";
import { default as withdrawAy7T0OF4kKp9gkXzM6VIsE9__RgKgRPfn5CZxrcUazIMeta } from "/app/pages/payment-claims/[id]/withdraw.vue?macro=true";
import { default as upload_45documentsxwNkfLtMWCHERq5SdqUhYGzCy6G4WLlrEGAw5KEApDEMeta } from "/app/pages/appeals/[id]/upload-documents.vue?macro=true";
import { default as _91_91step_93_93Pk6rEHdboIjRMjNI6z62bp2_45C5IQy9qQPeMKa9tGaiIMeta } from "/app/pages/subsidies/[id]/apply/[[step]].vue?macro=true";
import { default as _91_91step_93_93IuTjnyC1lz6kG47XdyIfpAzRodnOMvL_453ZWGX5HTemkMeta } from "/app/pages/payment-claims/file/[id]/[[step]].vue?macro=true";
import { default as upload_45documentsIVRhe9TUfNn16MZBk8Bp5oSAPzzeDoVcD0h2xgmzKjEMeta } from "/app/pages/applications/[id]/upload-documents.vue?macro=true";
import { default as upload_45documentsVX6eXYwsBkQ57rVn67gEUvfh5nvqmypjtT8GyGbI3pgMeta } from "/app/pages/payment-claims/[id]/upload-documents.vue?macro=true";
import { default as _91application_id_93yqzbYNC6i3A3VyRUPqqiJMkJmWoi9mhg9v0DUjiKy1AMeta } from "/app/pages/subsidies/apply-draft/[id]/[application_id].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/app/pages/logout.vue")
  },
  {
    name: "cookies",
    path: "/cookies",
    component: () => import("/app/pages/cookies.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/app/pages/profile.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    component: () => import("/app/pages/sign-in.vue")
  },
  {
    name: "support",
    path: "/support",
    component: () => import("/app/pages/support.vue")
  },
  {
    name: "authorize",
    path: "/authorize",
    component: () => import("/app/pages/authorize.vue")
  },
  {
    name: "auth-error",
    path: "/auth-error",
    meta: auth_45errortlyiiM_ajFw9AVCQbjXlzVBdqoleFtiGNosXQrGtbwAMeta || {},
    component: () => import("/app/pages/auth-error.vue")
  },
  {
    name: "styleguide",
    path: "/styleguide",
    component: () => import("/app/pages/styleguide.vue")
  },
  {
    name: "switch-ame",
    path: "/switch-ame",
    component: () => import("/app/pages/switch-ame.vue")
  },
  {
    name: "appeals-list",
    path: "/appeals/list",
    component: () => import("/app/pages/appeals/list.vue")
  },
  {
    name: "appeals-open",
    path: "/appeals/open",
    component: () => import("/app/pages/appeals/open.vue")
  },
  {
    name: "auth-details",
    path: "/auth-details",
    component: () => import("/app/pages/auth-details.vue")
  },
  {
    name: "not-eligible",
    path: "/not-eligible",
    meta: not_45eligibleq3yQpD9kRPfnbrTwMHY_45jCjr7nLSO4HHI2353wOWtqEMeta || {},
    component: () => import("/app/pages/not-eligible.vue")
  },
  {
    name: "accessibility",
    path: "/accessibility",
    component: () => import("/app/pages/accessibility.vue")
  },
  {
    name: "appeals",
    path: "/appeals",
    component: () => import("/app/pages/appeals/index.vue")
  },
  {
    name: "appeals-closed",
    path: "/appeals/closed",
    component: () => import("/app/pages/appeals/closed.vue")
  },
  {
    name: "fimas-add-id",
    path: "/fimas/add/:id()",
    component: () => import("/app/pages/fimas/add/[id].vue")
  },
  {
    name: "subsidies",
    path: "/subsidies",
    component: () => import("/app/pages/subsidies/index.vue")
  },
  {
    name: "applications-list",
    path: "/applications/list",
    component: () => import("/app/pages/applications/list.vue")
  },
  {
    name: "fimas-select-id",
    path: "/fimas/select/:id()",
    component: () => import("/app/pages/fimas/select/[id].vue")
  },
  {
    name: "fimas-update-id",
    path: "/fimas/update/:id()",
    component: () => import("/app/pages/fimas/update/[id].vue")
  },
  {
    name: "user-satisfaction",
    path: "/user-satisfaction",
    component: () => import("/app/pages/user-satisfaction.vue")
  },
  {
    name: "appeals-id",
    path: "/appeals/:id()",
    component: () => import("/app/pages/appeals/[id]/index.vue")
  },
  {
    name: "applications",
    path: "/applications",
    component: () => import("/app/pages/applications/index.vue")
  },
  {
    name: "fimas-preview-id",
    path: "/fimas/preview/:id()",
    component: () => import("/app/pages/fimas/preview/[id].vue")
  },
  {
    name: "applications-active",
    path: "/applications/active",
    component: () => import("/app/pages/applications/active.vue")
  },
  {
    name: "applications-drafts",
    path: "/applications/drafts",
    component: () => import("/app/pages/applications/drafts.vue")
  },
  {
    name: "payment-claims-list",
    path: "/payment-claims/list",
    component: () => import("/app/pages/payment-claims/list.vue")
  },
  {
    name: "applications-history",
    path: "/applications/history",
    component: () => import("/app/pages/applications/history.vue")
  },
  {
    name: "payment-claims",
    path: "/payment-claims",
    meta: index_oWEB8xoh29Lqc6KneRceOMidWxQwwSeuz2qjfmgFUcMeta || {},
    component: () => import("/app/pages/payment-claims/index.vue")
  },
  {
    name: "appeals-id-withdraw",
    path: "/appeals/:id()/withdraw",
    component: () => import("/app/pages/appeals/[id]/withdraw.vue")
  },
  {
    name: "applications-id",
    path: "/applications/:id()",
    component: () => import("/app/pages/applications/[id]/index.vue")
  },
  {
    name: "applications-id-delete",
    path: "/applications/:id()/delete",
    component: () => import("/app/pages/applications/[id]/delete.vue")
  },
  {
    name: "applications-appeal-id",
    path: "/applications/appeal/:id()",
    component: () => import("/app/pages/applications/appeal/[id].vue")
  },
  {
    name: "payment-claims-id",
    path: "/payment-claims/:id()",
    component: () => import("/app/pages/payment-claims/[id]/index.vue")
  },
  {
    name: "applications-id-withdraw",
    path: "/applications/:id()/withdraw",
    component: () => import("/app/pages/applications/[id]/withdraw.vue")
  },
  {
    name: "payment-claims-id-withdraw",
    path: "/payment-claims/:id()/withdraw",
    component: () => import("/app/pages/payment-claims/[id]/withdraw.vue")
  },
  {
    name: "appeals-id-upload-documents",
    path: "/appeals/:id()/upload-documents",
    component: () => import("/app/pages/appeals/[id]/upload-documents.vue")
  },
  {
    name: "subsidies-id-apply-step",
    path: "/subsidies/:id()/apply/:step?",
    component: () => import("/app/pages/subsidies/[id]/apply/[[step]].vue")
  },
  {
    name: "payment-claims-file-id-step",
    path: "/payment-claims/file/:id()/:step?",
    component: () => import("/app/pages/payment-claims/file/[id]/[[step]].vue")
  },
  {
    name: "applications-id-upload-documents",
    path: "/applications/:id()/upload-documents",
    component: () => import("/app/pages/applications/[id]/upload-documents.vue")
  },
  {
    name: "payment-claims-id-upload-documents",
    path: "/payment-claims/:id()/upload-documents",
    component: () => import("/app/pages/payment-claims/[id]/upload-documents.vue")
  },
  {
    name: "subsidies-apply-draft-id-application_id",
    path: "/subsidies/apply-draft/:id()/:application_id()",
    component: () => import("/app/pages/subsidies/apply-draft/[id]/[application_id].vue")
  }
]